import { Component } from '@verndale/core';
import createScrollShapes from '../helpers/createScrollShapes';

class SimpleMasthead extends Component {
  setupDefaults() {
    this.dom = {
      container: this.el.querySelector('.container')
    };
    this.buildShapes();
  }

  buildShapes() {
    this.dom.shapes = createScrollShapes({
      containerEl: this.dom.container,
      count: 3,
      prefix: 'simple-masthead__',
      scrollAnimate: false
    });
  }
}

export default SimpleMasthead;
